import React from 'react';
import { history } from 'routes/history';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LOAN } from '../constants/userProfile';
import Fioc from './FIOC/FIOC';
import DocumentationUpload from './DocumentationUpload/DocumentationUpload';
import StandBy from './Standby/Standby';
import TransferOtp from './transferOtp/transferOtp';
import PersonalInfo from './PersonalInfo/PersonalInfo';
import Contracting from './Contracting';
import ValidationResponse from './ValidationResponse/ValidationResponse';
import IneLoan from './IneLoan/IneLoan';
import { BASE_PATH } from 'constants/index';

import {
    ARES_LOADING,
    PERSONAL_INFORMATION,
    FIOC,
    IDENTIFICATION,
    DOCUMENTATION,
    STANDBY_LOAN,
    CONTRACTING_LOAN,
    PENDING_OTP,
    TRANSFER_OTP,
    RESULT_LOAN_APPROVED,
    RESULT_LOAN_COUNTEROFFER,
    SUCCESS_LOAN,
    INE_LOAN,
    SIGNING_CONTRACT,
    BATCH,
    PRE_CANCELED,
    SIGNATURE_KEY,
} from './commons/constants/steps';
import { loanStatus } from 'actions/aresActions';
import SuccessLoan from './successLoan/SuccessLoan';
import { showPreLoader, hidePreLoader } from 'actions/preLoaderActions';
import SigningContract from './SigningContract/SigningContract';
import SignatureKeyAres from 'components/SignatureKey/SignatureKeyAres';
import { VideoSelfieContainer } from './identification/videoselfie/VideoSelfieContainer';
import SessionTimeOut from 'components/sessionTimeOut/SessionTimeOut';

const formActions = require('react-redux-form').actions;
const optionsActions = require('actions/optionsActions');
const Storage = require('utilities/storage');

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null,
        };
    }

    async componentDidMount() {
        const { formActions, optionsActions, getLoanStatus, showPreLoader } = this.props;
        const accessTokenCookie = Storage.cookies.get('accessToken');
        if (!accessTokenCookie) {
            // User has not logged in or didn't reach to trigger a /register (complete first form), so start a new one
            formActions.change('userProfile.investmentType', LOAN);
            formActions.change('userProfile.status', PERSONAL_INFORMATION);
            showPreLoader();
        } else {
            formActions.change('userProfile.accessToken', accessTokenCookie);
            const { status } = await getLoanStatus(accessTokenCookie);
            if (!status) {
                optionsActions.setLoadAres(true);
                formActions.change('userProfile.status', 'aresLoading');
            }
        }
    }

    componentDidUpdate() {
        const { hidePreLoader, showPreLoader, userProfile } = this.props;

        if (userProfile.dossierId || userProfile.status === PERSONAL_INFORMATION || userProfile.uploadingDocuments) {
            return;
        }

        userProfile.chargingLoan ? showPreLoader() : hidePreLoader();
    }

    getComponentToRender() {
        const {
            userProfile: { status },
        } = this.props;

        switch (status) {
            case PERSONAL_INFORMATION:
                return <PersonalInfo />;
            case FIOC:
                return <Fioc />;
            case IDENTIFICATION:
                return <VideoSelfieContainer />;
            case DOCUMENTATION:
                return <DocumentationUpload />;
            case STANDBY_LOAN:
                return <StandBy />;
            case PENDING_OTP:
            case TRANSFER_OTP:
                return <TransferOtp />;
            case ARES_LOADING:
                return <React.Fragment />;
            case CONTRACTING_LOAN:
                return <Contracting />;
            case RESULT_LOAN_COUNTEROFFER:
            case RESULT_LOAN_APPROVED:
                return <ValidationResponse />;
            case SUCCESS_LOAN:
                return <SuccessLoan />;
            case INE_LOAN:
                return <IneLoan />;
            case SIGNING_CONTRACT:
                return <SigningContract />;
            case SIGNATURE_KEY:
                return <SignatureKeyAres />;
            case BATCH:
            case PRE_CANCELED:
                history.push(`${BASE_PATH}/errors`);
                break;
            default:
                break;
        }
    }

    renderSessionTimeout() {
        if (__ENV__ === 'LOCAL') {
            return null;
        }

        return <SessionTimeOut />;
    }

    render() {
        return (
            <React.Fragment>
                {this.renderSessionTimeout()}
                {this.getComponentToRender()}
            </React.Fragment>
        );
    }
}

export const AresApp = connect(
    state => ({
        userProfile: state.userProfile,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        getLoanStatus: bindActionCreators(loanStatus, dispatch),
        hidePreLoader: bindActionCreators(hidePreLoader, dispatch),
        showPreLoader: bindActionCreators(showPreLoader, dispatch),
    })
)(App);
